import enums from '@/plugins/enums'
import utils from '@/plugins/utils'
import store from '@/store'

const { requestStatus: status } = enums

export default (request) => {
  try {
    const config = store.getters.getConfig
    let valuation

    const isDispatch = config.DISPATCHED_DEPLOYMENTS?.length > 0
    request.deployment = isDispatch ? request.customer : false

    request.badges = []

    if (request.payment_summary?.is_refund_needed) {
      request.badges.push(enums.badgesStatus.REFUND_NEEDED)
    }

    if (request.status === status.SUBMITTED) {
      if (
        request.first_submission_at
        && new Date(request.last_submission_at).getTime() > new Date(request.first_submission_at).getTime()
      ) {
        request.badges.push(enums.badgesStatus.RESUBMITTED)
      }

      if (
        request.features?.renovation_cost
        || request.features?.energetic_renovation_cost
        || request.features?.non_energetic_renovation_cost
      ) {
        request.badges.push(enums.badgesStatus.HAS_RENOVATION)
      }

      const apt_status = request.latest_appointment?.status
      const payment_status = request.payment_summary?.status
      const pricing_flag = request.payment_summary?.pricing_flag

      if (request.borrower_status === 'registration_pending') {
        request.badges.push(enums.badgesStatus.NEEDS_BORROWER_EMAIL)
      }
      else if (payment_status === 'missing_price' || pricing_flag === 'custom_quote') {
        request.badges.push(enums.badgesStatus.CUSTOM_QUOTE_REQUIRED)
      }
      else if (
        payment_status === 'payment_needed'
        || payment_status === 'payment_pending'
        || request.borrower_status === 'details_pending'
      ) {
        request.badges.push(enums.badgesStatus.NEEDS_BORROWER_ACTION)
      }
      else {
        switch (apt_status) {
          case enums.appointmentStatus.PENDING_CONFIRMATION:
            request.badges.push(enums.badgesStatus.APPOINTMENT_PENDING_CONFIRMATION)
            break
          case enums.appointmentStatus.CANCELLED:
            request.badges.push(enums.badgesStatus.APPOINTMENT_CANCELLED)
            break
          case enums.appointmentStatus.CANCELLED_BY_VALUER:
            request.badges.push(enums.badgesStatus.APPOINTMENT_CANCELLED_BY_VALUER)
            break
          case enums.appointmentStatus.CONFIRMED:
            request.badges.push(enums.badgesStatus.APPOINTMENT_CONFIRMED)
            break
        }
      }
    }

    if (
      config.REQUIRE_OWNER_REVIEW_FOR_DVM
      && !request.accepted_by_owner_at
      && request.valuation_type === enums.modules.DVM
      && request.status === enums.requestStatus.VALUED
    ) {
      request.badges.push(enums.badgesStatus.REPORT_NEEDS_OWNER_APPROVAL)
    }

    if (request.status === enums.requestStatus.VALUED && !request.report_ref) {
      request.badges.push(enums.badgesStatus.REPORT_GENERATION_NEEDED)
    }

    if (request.valuation) {
      valuation = { ...request.valuation }
      if (valuation.date) {
        valuation.date = new Date(Array.isArray(valuation.date) ? valuation.date[0] : valuation.date)
        if (typeof valuation.date === 'string') {
          valuation.date = utils.parseFUDate(valuation.date)
        }
      }
      // TODO: currently ignoring the override_price logic (dvm only). decide whether it's relevant long term and include it here accordingly
      // TODO: check if it is needed to default valuation.internal_remarks to ''
      // isLoading.value = false

      // TODO: do we really need this insanity in the frontend?

      // FIXME: this seems to be defined already at the root level:
      valuation.package_type = request.features.renovation_cost > 0 ? 'renovation_light' : 'classic'

      let marketValue = valuation.market_value

      if ((marketValue ?? null) === null && request.avm_transaction?.status === 200) {
        valuation.type = 'avm'
        marketValue = request.avm_transaction.body.estimation.asking_price_q50

        valuation.valuer = '-'
        valuation.date = new Date(Date.now())
        if (request.avm_rental.status == 200 && (valuation.rental_value ?? null) === null) {
          valuation.rental_value = request.avm_rental.body.estimation.asking_price_q50
        }
        if (marketValue && (valuation.forced_sale_value ?? null) === null) {
          valuation.forced_sale_value = utils.forced_sale_value(marketValue)
        }
      }
      if (
        !valuation.market_value_post_renovation
        && valuation.date
        && new Date(valuation.date) < new Date(2023, 8, 17, 0, 0, 0)
        && valuation.package_type === 'renovation_light'
      ) {
        if (valuation.date < new Date(2022, 5, 10, 0, 0, 0)) {
          valuation.market_value_post_renovation = marketValue + request.features.renovation_cost / 4
          marketValue = marketValue - request.features.renovation_cost / 2
        }
        else {
          valuation.market_value_post_renovation = marketValue + (request.features.renovation_cost * 3) / 4
        }
        valuation.forced_sale_value_post_renovation = utils.forced_sale_value(
          valuation.market_value_post_renovation,
        )
      }

      if (
        !valuation.market_value_pre_construction
        && valuation.date
        && new Date(valuation.date) < new Date(2023, 8, 17, 0, 0, 0)
        && request.features.f_parcel_cost
      ) {
        valuation.market_value_pre_construction = request.features.f_parcel_cost
        valuation.forced_sale_value_pre_construction = utils.forced_sale_value(request.features.f_parcel_cost)
      }

      if (
        !valuation.construction_cost
        && valuation.date
        && new Date(valuation.date) < new Date(2023, 8, 17, 0, 0, 0)
        && request.features.construction_cost
      ) {
        valuation.construction_cost = request.features.construction_cost
      }

      request.valuation = valuation
      // End of Valuation post-treatment
    }

    const recompute_risk = (dist, buffer) => {
      return isNaN(dist) ? null : dist <= buffer ? 'High' : 'None'
    }

    // TODO: move this to the backend FFS
    if (request.features) {
      request.features = {
        ...request.features,
        f_flood_risk_insurance_exclusion_1m: recompute_risk(
          request.features.f_dist_building_flood_insurance_exclusion,
          1,
        ),
        f_parcel_flood_risk_insurance_exclusion_1m: recompute_risk(
          request.features.f_dist_parcel_flood_insurance_exclusion,
          1,
        ),
      }
    }

    // TODO: figure out a way to have formatted reactive synthetic properties (like fullAddress)
    // without having to use a closure (eg that can leave outside of the request scope)
    // -> alternatively, we only use getXXX() methods
    // TODO: move these functions out of utils and back here
    const features = request.ers_data || request.features
    if (request.address) {
      request.fullAddress = utils.full_address(request.address, features)
      request.viaAddress = utils.via_address(request.address, features)
      request.shortAddress = utils.short_address(request.address, features)
      request.displayAddress
        = request.viaAddress !== '' ? `${request.fullAddress} (via ${request.viaAddress})` : request.fullAddress
      // request.formattedAddress = utils.formatAddress(request.address)
      request.formattedAddress = {
        firstLine:
          request.address.streetname && request.address.streetnumber
            ? `${request.address.streetname} ${request.address.streetnumber}${
              request.address.boxnumber ? ` b ${request.address.boxnumber}` : ''
            }`
            : 'n/a',
        secondLine:
          request.address.postalcode && request.address.municipality
            ? `${request.address.postalcode} ${request.address.municipality}`
            : 'n/a',
      }
    }

    request.regionName = features?.region && utils.iso_regions[features?.region]

    if (request.valuation_type === enums.modules.OVM) {
      const borrower = request.borrower

      const isCustomQuoteNeeded = request.payment_summary?.pricing_flag === enums.pricingFlag.CUSTOM_QUOTE && !request.is_customized_fee

      request.hints = {
        isBorrowerHavingContactDetails:
          borrower && borrower.email && borrower.first_name && borrower.last_name && borrower.phone,
        isPaymentNeeded: request.payment_summary?.is_payment_needed,
        isCustomQuoteNeeded,
      }
    }

    return {
      ...request,
      ers_data: features,
      // address: displayAddress(request),
      document_info: request.document_info ?? {},
      building_type: features?.f_building_type ?? null,
      modified_at: new Date(request.modified_at),
      created_at: new Date(request.created_at),
      referral_at: request.referral_at ? new Date(request.referral_at) : null,
      valuation,
      request_language: request.last_submission_lang,
      has_avm: !enums.specialHandlingBuildingTypes.has(features?.f_building_type),
    }
  }
  catch (error) {
    // TODO: handle this in a cleaner way (proper error logging to the store)
    console.error({ error, request })
    return { error: true }
  }
}
